import React, { useEffect, useRef, useState } from 'react'
import Proptypes from 'prop-types'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../../utils/common-utils'
import DOMPurify from 'dompurify'
import { pipe } from '../../../../../common/utils'

const Hero = props => {
  const { heading, content, facetImage, backgroundImageArray, mobileBgImageArray } = props
  const env = getCWPEnvironmentForURL(window.location.href)
  const facetRef = useRef(null)
  const backgroundRef = useRef(null)
  const [containerHeight, setContainerHeight] = useState(0)
  const [imageSet, setImageSet] = useState([])

  // This adjusts the container to include the portion of the facet that doesn't overlap the image.
  // the height of the facet is dynamic. in mobile view for example it's longer than in desktop view
  useEffect(() => {
    const backgroundDimensions = backgroundRef.current.getBoundingClientRect()
    const facetDimensions = facetRef.current.getBoundingClientRect()
    setContainerHeight(
      backgroundDimensions.height + facetDimensions.bottom - backgroundDimensions.bottom
    )
  }, [])

  useEffect(() => {
    setImageSet(self.innerWidth < 1025 ? mobileBgImageArray : backgroundImageArray)
  }, [])

  /**
   * Formats the proper url to fetch the image in CMS when used as a style: background-image
   * @param {String} path
   * @returns {String}
   */
  const getImageUrl = path => {
    const sanitizedPath = DOMPurify.sanitize(`${APIENDPOINT(env).baseGallery}${path}`)
    return `url(${sanitizedPath})`
  }

  /**
   * Gets the relative path to the image if the document has one.
   * @param {Object} image as defined in bloomreach API
   * @returns {String}
   */
  const getImagePathFromDoc = image => {
    return image && image.image._meta.mirror && image.image._meta.mirror.path
      ? image.image._meta.mirror.path
      : ''
  }

  /**
   * Selects a random image from array.
   * @param {Array} images
   * @returns {Object}
   */
  const selectRandomImage = images => {
    if (images.length === 1) {
      return images[0]
    }
    const imageIndex = Math.floor(Math.random() * images.length)
    return images[imageIndex]
  }

  const backgroundImageUrl = pipe(selectRandomImage, getImagePathFromDoc, getImageUrl)(imageSet)
  const facetImageUrl = pipe(getImagePathFromDoc, getImageUrl)(facetImage)

  return (
    <section className='u-posRelative' style={{ height: containerHeight || 'auto' }}>
      <div
        className='Hero-topic-front hero-background u-sizeFull'
        style={{
          backgroundImage: backgroundImageUrl,
        }}
        ref={backgroundRef}
      />
      <div className='hero-facet-container u-sizeConstrained u-flex u-flexAlignItemsCenter u-flexJustifyCenter'>
        <div
          className='hero-facet u-flexCol u-size10of12 u-paddingVert40 u-sm-paddingVert24 u-paddingHoriz32 u-sm-paddingHoriz20 Content u-textCenter u-flexJustifyCenter'
          ref={facetRef}
          style={{
            backgroundImage: facetImageUrl,
          }}>
          <h1 className='u-textColorWhite'>{heading}</h1>
          <div
            className='Content Content--large u-marginTop8 u-textCenter u-flexJustifyCenter'
            dangerouslySetInnerHTML={{ __html: content.content }}
          />
        </div>
      </div>
    </section>
  )
}
Hero.propTypes = {
  heading: Proptypes.string,
  content: Proptypes.object,
  facetImage: Proptypes.object,
  backgroundImageArray: Proptypes.array,
  mobileBgImageArray: Proptypes.array,
}
export default Hero
